// import carIcon from "../../assets/iconos/car.png"

import { INT_TIPO_USUARIO } from "../../utils/const/int-const";

export const MODULOS_ADMINISTRACION = [
    {
        id: 2,
        titulo: 'Administrar Cuenta',
        descripcion: 'Cuenta',
        // icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/administrar-cuenta/cuenta',
        tipo: INT_TIPO_USUARIO.REFUGIO,
    },
    {
        id: 1,
        titulo: 'Gestionar Mascota',
        descripcion: 'Gestionar Mascota',
        // icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-mascota/listar-mascota',
        tipo: INT_TIPO_USUARIO.REFUGIO,
    },
    {
        id: 3,
        titulo: 'Gestionar QR',
        descripcion: 'Gestionar QR',
        // icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/administrar-qr/qr',
        tipo: INT_TIPO_USUARIO.REFUGIO,
    },
    {
        id: 4,
        titulo: 'Gestionar Publicidad',
        descripcion: 'Gestionar Publicidad',
        // icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/publicidad/publicidad',
        tipo: INT_TIPO_USUARIO.PUBLICIDAD,
    },
];